module.exports = __webpack_public_path__ + "static/media/facebook.f9ffe7a2.png";